export interface ScrollOffset {
  left?: number;
  top?: number;
}

export const DEFAULT_SCROLL_OFFSET: ScrollOffset = {
  left: 50,
  top: 100
};

export const INTERRUPT_MOUSE_EVENTS: string[] = [
  "mousedown",
  "wheel",
  "DOMMouseScroll",
  "mousewheel",
  "touchmove"
];

export const INTERRUPT_KEYS: string[] = [
  "Tab",
  "Escape",
  "Space",
  " ",
  "PageUp",
  "PageDown",
  "End",
  "Home",
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  "Left",
  "Up",
  "Right",
  "Down"
];
